import React from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { withDialogFooterSpacing } from './dialogFooterSpacing';

interface ConfirmationDialogProps {
  visible: boolean;
  onHide: () => void;
  onConfirm?: () => void; // Требуется если нет футера
  footer?: React.ReactNode;
  // Опциональные параметры с значениями по умолчанию
  header?: string;
  width?: string;
  // Основной контент
  entityType?: string;
  entityName?: string | React.ReactNode; // Поддержка JSX для имени
  warnings?: React.ReactNode[]; // Массив React-элементов для гибкости
  // Для кастомных сценариев
  children?: React.ReactNode; // Альтернатива стандартному контенту
}

const DeleteConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  header = 'Подтверждение удаления', // Значение по умолчанию
  visible,
  onHide,
  footer,
  onConfirm,
  width = '30vw',
  entityType,
  entityName,
  warnings,
  children
}) => {
  const defaultFooter = (
    <div>
      <Button
        label="Да, удалить"
        onClick={() => {
          onConfirm?.();
          onHide();
        }}
        className="p-button-danger"
      />
      <Button
        label="Нет, отмена"
        onClick={onHide}
        className="p-button-secondary"
      />
    </div>
  );

  const renderContent = () => {
    if (children) return children;
    return (
      <div className="confirmation-content">
        <div>
          Вы уверены, что хотите удалить <b>{entityType}</b>
          {entityName && <> {entityName}</>}?
          {warnings?.map((warning, index) => (
            <React.Fragment key={index}>
              <br />
              {warning}
            </React.Fragment>
          ))}
          <br />
          Данную операцию невозможно отменить.
        </div>
      </div>
    );
  };

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width }}
      footer={footer || defaultFooter}
      onHide={onHide}
      breakpoints={{ '960px': '75vw', '640px': '90vw' }}
      pt={withDialogFooterSpacing()}
    >
      {renderContent()}
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
